<template>
    <div class="options">
        <p class="text-answer">Tijd</p>
    </div>
</template>

<script setup lang="ts">

</script>
